import React, { useState, useEffect, useRef } from 'react';
import ImagibleItems from '../home/ImagibleItems/ImagibleItems';
import HorizontalScroll from 'react-scroll-horizontal';
import Select from 'react-select';
import searchIconDark from '../../assets/images/search-icon-dark.svg';
import searchIconLight from '../../assets/images/search-icon-light.svg';
import iconSettings from '../../assets/images/icon-settings.svg';
import { Link } from "react-router-dom";
import siteLogoDarkMode from '../../assets/images/logo-dark-mode.svg';
import siteLogoLightMode from '../../assets/images/logo-light-mode.svg';
import { beforeNavbar, getNavbar, setMenu } from '../home/navBar/navBar.action'
import { beforeCollection, getCollections } from '../collections/collections.actions'
import { beforeUser, getCreators } from '../user/user.action'
import { setCatId, setAll } from '../home/ImagibleItems/ImagibleItems.action'
import { beforeExplore, getExplore } from '../home/ImagibleItems/ImagibleItems.action'
import { connect } from 'react-redux';
import { Navbar, NavDropdown, Form, Button } from "react-bootstrap";
import { ENV } from '../../config/config';
import { beforeModalMenu } from '../modal-menu/modal-menu.action'
const child = { height: `100%` }


const Template = (props) => {
	const nftsRef = useRef(null)
	const [selectedOption, setSelectedOption] = useState({ value: 'chocolate', label: 'Chocolate' })
	const handleChange = e => {
		setSelectedOption(e)
	};

	const options = [
		{ value: 'chocolate', label: 'Chocolate' },
		{ value: 'strawberry', label: 'Strawberry' },
		{ value: 'vanilla', label: 'Vanilla' },
	];

	const [cat, setCat] = useState(null)
	const [filterCheck, setFilterCheck] = useState(false)
	const [collections, setCollections] = useState(null);
	const [authors, setAuthors] = useState(null);
	const [filReq, setFilReq] = useState(false);
	const [filters, setFilters] = useState({
		categoryId: '',
		collectionId: '',
		status: '',
		minPrice: '',
		maxPrice: '',
		authorId: ''
	})
	const [filDef, setFilDef] = useState({
		status: '',
		collection: '',
		category: '',
		creator: ''
	})

	useEffect(() => {
		props.getNavbar()
		props.getCollections()
		props.getCreators()
	}, [])

	useEffect(() => {
		if (props.navBar.navBarAuth) {
			setCat(props.navBar.navBar)
			props.beforeNavbar()
		}
	}, [props.navBar.navBarAuth])

	useEffect(() => {
		if (props.collection.getAuth) {
			setCollections(props.collection.collections)
			props.beforeCollection()
		}
	}, [props.collection.getAuth])

	useEffect(() => {
		if (props.user.creatorsAuth) {
			setAuthors(props.user.creators.creators)
			props.beforeUser()
		}
	}, [props.user.creatorsAuth])

	useEffect(() => {
		if (props.modalMenu.catAuth) {
			nftsRef.current?.getCatNFTs(props.modalMenu.catId)
			props.beforeModalMenu()
		}
	}, [props.modalMenu.catAuth])

	const activeCat = (id) => {
		document.querySelectorAll('.nav-lnk').forEach(element => {
			element.classList.remove('active')
		});
		document.querySelector(`#lnk-${id}`).classList.add('active');
	}

	const getCatNFTs = (categoryId) => {
		// props.setCatId(categoryId);
		if (categoryId === 1) {
			activeCat('allitems');
		}
		else {
			activeCat(categoryId);
		}
		nftsRef.current?.getCatNFTs(categoryId)
	}

	const filterSort = () => {
		if (filterCheck) {
			return (
				<header className="pl-4 main-header home-header bottom filters-header pt-3">
					<nav data-aos="zoom-out" data-aos-delay={800} className="navbar navbar-expand">
						<div className="d-flex flex-column">
							<div className="container-fluid">
								<div className="row">
									<div className="col-12">
										<h3 className="nav-heading mb-3">
											<span className="top-menu-text">Filters &amp; Sort</span>
											<span className="left-menu-text d-none">Explore by Categories</span>
										</h3>
									</div>
								</div>
							</div>
							<div className="container-fluid">
								<div className="row">
									<div className={localStorage.getItem('menu') === 'true' ? "col-12" : "col-md-4 col-sm-6"}>
										<Form.Group>
											<select className="form-select pr-3 mr-3 border border-white" aria-label="Default select example" onChange={(e) => { setFilters({ ...filters, status: e.target.value }); setFilDef({ ...filDef, status: e.target.value }); }} value={filDef.status}>
												<option value={''} selected>Status</option>
												<option value={1}>On Auction</option>
												<option value={2}>Has Offer</option>
												<option value={3}>New</option>
											</select>
										</Form.Group>
									</div>
									<div className={localStorage.getItem('menu') === 'true' ? "col-12" : "col-md-4 col-sm-6"}>
										<Form.Group>
											<select className="form-select pr-3 mr-3 border border-white" aria-label="Default select example" onChange={(e) => { setFilters({ ...filters, collectionId: e.target.value }); setFilDef({ ...filDef, collection: e.target.value }); }} value={filDef.collection}>
												<option value={''} selected>
													Collection
												</option>
												<option value={''}>
													All
												</option>
												{
													collections && collections.length ? collections.map((item, index) => {
														return (
															<option key={index} value={item._id}>
																{item.name}
															</option>
														)
													}) : ''
												}
											</select>
										</Form.Group>
									</div>
									<div className={localStorage.getItem('menu') === 'true' ? "col-12" : "col-md-4 col-sm-6"}>
										<Form.Group>
											<select className="form-select pr-3 mr-3 border border-white" aria-label="Default select example" onChange={(e) => { setFilters({ ...filters, categoryId: e.target.value }); setFilDef({ ...filDef, category: e.target.value }); }} value={filDef.category}>
												<option value={''} selected>
													Category
												</option>
												<option value={''}>
													All
												</option>
												{
													cat && cat.length ? cat.map((item, index) => {
														return (
															<option key={index} value={item._id}>
																{item.name}
															</option>
														)
													}) : ''
												}
											</select>
										</Form.Group>
									</div>
									<div className={localStorage.getItem('menu') === 'true' ? "col-12" : "col-md-4 col-sm-6"}>
										<Form.Group>
											<select className="form-select pr-3 mr-3 border border-white" aria-label="Default select example" onChange={(e) => { setFilters({ ...filters, creatorId: e.target.value }); setFilDef({ ...filDef, creator: e.target.value }); }} value={filDef.creator}>
												<option value={''} selected>
													Creator
												</option>
												<option value={''}>
													All
												</option>
												{
													authors && authors.length ? authors.map((item, index) => {
														return (
															<option key={index} value={item._id}>
																{item.username}
															</option>
														)
													}) : ''
												}
											</select>
										</Form.Group>
									</div>
									<div className={localStorage.getItem('menu') === 'true' ? "col-12" : "col-md-4 col-sm-6"}>
										<Form.Group>
											<div className="d-flex justify-content-between">
												<div className="price-holder">
													<Form.Control type="number" id="filter-min-price" placeholder="Min" min="0"
														onChange={(e) => { setFilters({ ...filters, minPrice: e.target.value }); }}
													/>
												</div>
												<div className="price-holder">
													<Form.Control type="number" id="filter-max-price" placeholder="Max" min="0"
														onChange={(e) => { setFilters({ ...filters, maxPrice: e.target.value }); }}
													/>
												</div>
											</div>
										</Form.Group>
									</div>
									<div className={localStorage.getItem('menu') === 'true' ? "col-12" : "col-md-4 col-sm-6"}>
										<Form.Group>
											<div className="d-flex justify-content-between filter-btns-holder">
												<Button className="btn btn-bordered-white"
													onClick={(e) => {
														let qs = ENV.objectToQueryString(filters);
														props.getExplore(qs);
														setFilReq(false)
														for (const property in filters) {
															if (filters[property] !== '') {
																setFilReq(true)
															}
														}
													}}
												>Apply</Button>
												<Button className="btn btn-bordered-white" onClick={(e) => {
													setFilters({
														status: '',
														minPrice: '',
														maxPrice: '',
														collectionId: '',
														categoryId: '',
														creatorId: ''
													});
													setFilDef({
														status: '',
														collection: '',
														category: '',
														creator: ''
													});
													document.querySelector('#filter-min-price').value = '';
													document.querySelector('#filter-max-price').value = '';
												}}
												>Reset</Button>

											</div>
										</Form.Group>
									</div>
								</div>
								<Navbar.Collapse id="basic-navbar-nav">
								</Navbar.Collapse>
							</div>
						</div>
					</nav>
				</header>
			)
		}
	}

	return (
		<React.Fragment>
			<header id="header" className="main-header home-header bottom">
				{/* Navbar */}
				<nav data-aos="zoom-out" data-aos-delay={800} className="navbar navbar-expand">
					<div className="container header">
						<div className="nav-container">
							<div className="left-menu-logo">
								<strong className="text-center d-block">
									<Link className="d-inline-block align-top" to="/">
										<img className="navbar-brand-sticky logo-dark-mode" src={siteLogoDarkMode} alt="sticky brand-logo" />
										<img className="navbar-brand-sticky logo-light-mode" src={siteLogoLightMode} alt="sticky brand-logo" />
									</Link>
								</strong>
							</div>
							<h3 className="nav-heading">
								<span className="top-menu-text">Explore</span>
								<span className="left-menu-text d-none">Explore by Categories</span>
							</h3>
							{/* Navbar */}
							<div className="topmenu-nav-holder">
								<HorizontalScroll reverseScroll>
									<div className="parentDiv" style={child}>
										<ul className="navbar-nav items xxv hide-in-mobile">
											{/* <li id={`lnk-idOfAll`} className={'nav-lnk active'}><Link to="" onClick={(e) => {
												props.setAll();
												activeCat('idOfAll');
											}}>All</Link></li> */}
											<li id={`lnk-allitems`} className={'nav-lnk active'}>
												<Link to="" onClick={() => getCatNFTs(1)}>All</Link>
											</li>
											{
												cat ? cat.map((item, key) => {
													return (
														<li key={key} id={`lnk-${item._id}`} className={'nav-lnk'}>
															<Link to="" onClick={() => getCatNFTs(item._id)}>{item.name}</Link>
														</li>
													)
												}) : ''
											}
										</ul>
									</div>
								</HorizontalScroll>
							</div>
							<div className="leftmenu-nav-holder">
								<ul className="navbar-nav items xxb hide-in-mobile">
									<li id={`lnk-allitems`} className={'nav-lnk active'}>
										<Link to="" onClick={() => getCatNFTs(1)}>All</Link>
									</li>
									{
										cat ? cat.map((item, key) => {
											return (
												<li key={key} id={`lnk-${item._id}`} className={'nav-lnk'}>
													<Link to="" onClick={() => getCatNFTs(item._id)}>{item.name}</Link>
												</li>
											)
										}) : ''
									}
								</ul>
							</div>
							<ul className="list-unstyled top-menu-filter">
								<li onClick={() => {
									setFilterCheck(!filterCheck);
								}}>
									<Link to=""><i className="fas fa-sliders-h mr-3"></i>Filters &amp; Sort</Link>
								</li>
							</ul>
							{/* Navbar Icons */}
							{/* <ul className="navbar-nav icons">
							<li className="nav-item">
								<Link to="#" className="nav-link" data-toggle="modal" data-target="#search">
									<i className="fas fa-search" />
								</Link>
							</li>
						</ul> */}
							{/* Navbar Toggler */}
							<ul className="navbar-nav toggle d-block d-xl-none">
								<li className="nav-item">
									<Link to="#" className="nav-link" data-toggle="modal" data-target="#menu" onClick={() => { props.setMenu() }}>
										<i className="fas fa-bars toggle-icon m-0" />
									</Link>
								</li>
							</ul>
							{/* Navbar Action Button */}
						</div>
					</div>
				</nav>
				<div className="mobile-filter-row">
					{/* <ul className="list-unstyled">
						<li><Link to=""><i className="fas fa-sliders-h mr-3"></i>Filters &amp; Sort</Link></li>
					</ul> */}
					<ul className="navbar-nav toggle">
						<li className="nav-item">
							<Link to="#" className="nav-link" data-toggle="modal" data-target="#menu" onClick={() => { props.setMenu() }}>
								<i className="fas fa-bars toggle-icon m-0" />
							</Link>
						</li>
					</ul>
				</div>
				<div className="filter-row">
					<span className="filter-result-text mb-3 mb-lg-0">11.354 results</span>
					<div className="select-holder mb-3 mb-lg-0">
						<Select
							value={selectedOption}
							onChange={(e) => handleChange(e)}
							options={options}
							classNamePrefix="react_select"
						/>
					</div>
					<div className="select-holder">
						<Select
							value={selectedOption}
							onChange={(e) => handleChange(e)}
							options={options}
							classNamePrefix="react_select"
						/>
					</div>
				</div>
			</header>


			{filterSort()}



			<ImagibleItems ref={nftsRef} filter={filReq} />
		</React.Fragment>
	)
}

const mapStateToProps = state => ({
	error: state.error,
	navBar: state.navBar,
	explore: state.explore,
	collection: state.collection,
	user: state.user,
	explore: state.explore,
	app: state.app,
	modalMenu: state.modalMenu
});

export default connect(mapStateToProps, { beforeNavbar, getNavbar, setCatId, setAll, beforeCollection, getCollections, beforeUser, getCreators, beforeExplore, getExplore, beforeModalMenu, setMenu })(Template)
